import { v4 as uuidv4 } from 'uuid';
import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays';
import { FormSpy } from 'react-final-form';

import {
  getActKnoWitnessBlockId,
  getActKnoWitnessesBlockId,
} from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { Button } from 'UIPackage/MainModule/components/Button';
import { CloseButton } from 'UIPackage/MainModule/components/CloseButton';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { IKnmErknmFormActWitness } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormActWitness';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';

import styles from './ErknmActParticipants.module.scss';

interface IErknmActWitnessesProps {
  id: string;
  index?: number;
  name: string;
  isDisabledField: boolean;
  isDecision?: boolean;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
}

export const ErknmActWitnesses = ({
  id,
  index,
  name,
  formRef,
  isDisabledField,
  isDecision,
}: IErknmActWitnessesProps) => {
  const push = formRef?.current.mutators.push;
  const remove = formRef?.current.mutators.remove;

  const expertsBlockId = getActKnoWitnessesBlockId(id);

  const addField = (fieldName: string) => () =>
    !isDisabledField && push && push(`${name}.${fieldName}`, { listId: uuidv4(), isNew: true });
  const makeRemoveField = (fieldName: string, i: number) => () => {
    !isDisabledField && remove && remove(`${name}.${fieldName}`, i);
  };

  return (
    <>
      <FieldBlock
        id={expertsBlockId}
        label={'Привлеченные к проверке свидетели'}
        className={styles.GroupMarginBottom}
        button={
          <Button
            className="shared-btn-add"
            text="Добавить"
            type="button"
            variant="link"
            color="primary"
            disabled={isDisabledField}
            onClick={addField('involvedWitnesses')}
          />
        }
      >
        <FieldArray name={`${name}.involvedWitnesses`}>
          {({ fields }: FieldArrayRenderProps<IKnmErknmFormActWitness, HTMLElement>) => {
            if (!fields.length) {
              return null;
            }

            return (
              <Row>
                {fields.map((fieldName, i) => {
                  const fieldValue: IKnmErknmFormActWitness = fields.value?.[i];
                  const expertId = `${getActKnoWitnessBlockId(id, fieldValue.listId)}.fullName`;

                  return (
                    <Row key={expertId} margin="medium" isListItem notSpace id={expertId}>
                      <TextInputField
                        className={styles.SelectInputExperts}
                        name={`${fieldName}.fullName`}
                        placeholder={'Укажите свидетеля'}
                        isSearchable
                        disabled={isDisabledField}
                        size="medium"
                      />
                      <CloseButton
                        className="shared-deleting-row-btn"
                        onClick={makeRemoveField('involvedWitnesses', i)}
                      />
                    </Row>
                  );
                })}
              </Row>
            );
          }}
        </FieldArray>
      </FieldBlock>
      <FormSpy subscription={{ errors: true, touched: true }}>
        {props => {
          if (
            !isDecision &&
            index !== undefined &&
            props.errors?.acts &&
            props.errors?.acts[index]?.involvedWitnesses
          ) {
            const fieldError = props.errors.acts[index].involvedWitnesses;
            const isFieldTouched = props.touched?.[`acts[${index}].involvedWitnesses`];

            const errorMessage: string | undefined = fieldError
              ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
              : undefined;

            if (isFieldTouched && errorMessage && typeof fieldError === 'string') {
              return <p className={`${styles.expertsFormSpyMessage} shared-input-error`}>Поле не может быть пустым</p>;
            }
          }

          if (!isDecision && index === undefined && props.errors?.act && props.errors?.act?.involvedWitnesses) {
            const fieldError = props.errors.act.involvedWitnesses;
            const isFieldTouched = props.touched?.[`act.involvedWitnesses`];

            const errorMessage: string | undefined = fieldError
              ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
              : undefined;

            if (isFieldTouched && errorMessage && typeof fieldError === 'string') {
              return <p className={`${styles.expertsFormSpyMessage} shared-input-error`}>Поле не может быть пустым</p>;
            }
          }

          if (isDecision && props.errors?.act && props.errors?.act.involvedExperts) {
            const fieldError = props.errors.act.involvedExperts;
            const isFieldTouched = props.touched?.[`act.involvedExperts`];

            const errorMessage: string | undefined = fieldError
              ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
              : undefined;

            if (isFieldTouched && errorMessage && typeof fieldError === 'string') {
              return (
                <p className={`${styles.knoInspectorsFormSpyMessage} shared-input-error`}>Поле не может быть пустым</p>
              );
            }
          }

          return null;
        }}
      </FormSpy>
    </>
  );
};
